import React from "react";

const NoData = ({ message = "Δεν υπάρχουν δεδομένα" }) => (
  <div className="flex flex-col items-center justify-center py-16 text-center text-slate-400">
    <div className="text-5xl">🐟</div>
    <div className="mt-3 text-lg">{message}</div>
  </div>
);

export default NoData;
